// extracted by mini-css-extract-plugin
export default {"container":"SettingsNavigation_container__fpF9O","link":"SettingsNavigation_link__aEkS9"};